import styled from 'styled-components'

export const Container = styled.div`
  max-width: 80vw;
  font-size: 2.5rem;
`

export const Address = styled.p`
  text-align: center;
`

export const Map = styled.iframe`
  width: 70vw;
  height: 45rem;
  border:0;
  margin: 0 auto;
  display: block;
`